module.exports = __webpack_public_path__ + "media/img/pages/companies/isolutions-e7b45ddf685f2e96c5fa89b01be4e092.webp";